import { render, staticRenderFns } from "./container_leasing.vue?vue&type=template&id=2c28c258&scoped=true&"
import script from "./container_leasing.vue?vue&type=script&lang=js&"
export * from "./container_leasing.vue?vue&type=script&lang=js&"
import style0 from "./container_leasing.vue?vue&type=style&index=0&id=2c28c258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28c258",
  null
  
)

export default component.exports